module.exports = __webpack_public_path__ + "img/thinkHigherlogo.442c226b.png";